export default "__VITE_ASSET__761cc0ce__"